import React from "react";
import { useRouteData } from "react-static";
import { useI18n } from "../../I18nextProvider";

const Logo = () => {
  const i18n = useI18n();

  const current = useRouteData();
  const { lang, type, id } = current;

  const mcnLogoFr = require("../../assets/images/logo-musee-numerique-blanc.svg");
  const mcnLogoEn = require("../../assets/images/logo-musee-numerique-blanc-en.svg");

  const mcnLogoFile = lang === "fr" ? mcnLogoFr : mcnLogoEn;

  return (
    <div className="logos">
      <a target="_blank" className="srdp" rel="noreferrer" href={i18n.t("home.href.srdp")}>
        <img src={require("../../assets/images/srdp-logo-blanc.svg")} alt={i18n.t("home.logo.srdp")} />
      </a>
      <a target="_blank" className="idhp" rel="noreferrer" href={i18n.t("home.href.idhp")}>
        <img src={require("../../assets/images/idhp-logo.svg")} alt={i18n.t("home.logo.idhp")} />
      </a>
      <a target="_blank" className="cube" rel="noreferrer" href={i18n.t("home.href.cubenoir")}>
        <img src={require("../../assets/images/cubenoir-logo-blanc.svg")} alt={i18n.t("home.logo.cubenoir")} />
      </a>
      <a target="_blank" className="alt" rel="noreferrer" href={i18n.t("home.href.alt")}>
        <img src={require("../../assets/images/logo-alt-numerique.svg")} alt={i18n.t("home.logo.alt")} />
      </a>
      <a target="_blank" className="mnc" rel="noreferrer" href={i18n.t("home.href.mnc")}>
        <img src={mcnLogoFile} alt={i18n.t("home.logo.mnc")} />
      </a>
    </div>
  );
};

export default Logo;
